// This is how much time we wait for values in actions to load before we
// abort.
export const actionRunTimeout = 4000;
